<template>
    <div class="landing" v-if="dataFetched()">
        <home />
        <about />
        <service />
        <product-type />
        <product />
        <order-product />
        <process />
        <partner />
        <get-project />
        <technologies />
        <client />
        <custom-footer />
        <copy />
    </div>
    <!-- <div class="animation">
      <img src="../assets/img/logo-color.webp" style="width:20%" />
    </div>-->

    <!-- <b-spinner v-else class="spinner" style="width: 4rem; height: 4rem;color:var(--main-blue);margin-top: 22%;"
    label="Spinning"></b-spinner>-->

    <loader3 v-else />
</template>

<script>
import Home from "@/components/Home.vue"
import About from "@/components/About.vue"
import Service from "@/components/Service.vue"
import ProductType from "@/components/ProductType.vue"
import Partner from "@/components/Partner.vue"
import GetProject from "@/components/GetProject.vue"
import CustomFooter from "@/components/CustomFooter.vue"
import Product from "@/components/Product.vue"
import OrderProduct from "@/components/OrderProduct.vue"
import Client from "@/components/Client.vue"
import Loader3 from "@/components/Loader3.vue"
import Process from "@/components/Process.vue"
import Technologies from "@/components/Technologies.vue"
import Copy from "@/components/Copy.vue"
export default {
    name: "Landing",
    components: {
        Home,
        About,
        Service,
        ProductType,
        Partner,
        GetProject,
        CustomFooter,
        Product,
        OrderProduct,
        Client,
        Loader3,
        Process,
        Technologies,
        Copy
    },
    data() {
        return {
            scroll: '',
        };
    },
    methods: {
        dataFetched() {
            if (
                this.$store.state.about_section_data.length != 0 &&
                this.$store.state.service_data.length != 0 &&
                this.$store.state.product_data != 0 &&
                this.$store.state.client_data != 0 &&
                this.$store.state.partner_data != 0 && 
                this.$store.state.product_type_data != 0 &&
                this.$store.state.get_contact == true
            )
                return true
        },
        getService() {
            this.axios.get(this.$store.state.url + "services")
                .then(res => {
                    this.$store.state.service_data = res.data.list
                });
        },
        getPartner() {
            this.axios.get(this.$store.state.url + "partners")
                .then(res => {
                    this.$store.state.partner_data = res.data.list
                });
        },
        getAbout() {
            this.axios.get(this.$store.state.url + "abouts")
                .then(res => {
                    this.$store.state.about_section_data = res.data.list
                });
        },
        getClient() {
            this.axios.get(this.$store.state.url + "clients")
                .then(res => {
                    this.$store.state.client_data = res.data.list
                });
        },
        getProductType() {
            this.axios.get(this.$store.state.url + "product_types")
                .then(res => {
                    this.$store.state.product_type_data = res.data.list
                });
        },
        getProduct() {
            this.axios.get(this.$store.state.url + "products")
                .then(res => {
                    this.$store.state.product_data = res.data.list
                });
        },
        getContact() {
            this.axios.get(this.$store.state.url + "contact-us")
                .then(res => {
                    this.$store.state.contact_data = res.data.list
                    this.initContact(this.$store.state.contact_data)
                    this.$store.state.get_contact = true
                });
        },
        initContact(data) {
            data.forEach(element => {
                if (element.name == 'Whatsapp') {
                    this.$store.state.contact_data.whatsapp = element.value
                    this.$store.state.contact_data.whatsapp_link = "https://wa.me/00963" + this.$store.state.contact_data.whatsapp
                }
                if (element.name == 'Phone') {
                    this.$store.state.contact_data.phone = element.value
                    this.$store.state.contact_data.phone_link = "tel:+963" + this.$store.state.contact_data.phone
                }
                if (element.name == "Facebook")
                    this.$store.state.contact_data.facebook = element.value
                if (element.name == 'Instagram')
                    this.$store.state.contact_data.insta = element.value
                if (element.name == "Email") {
                    this.$store.state.contact_data.email = element.value
                    this.$store.state.contact_data.email_link = "mailto:" + this.$store.state.contact_data.email
                }
                if (element.name == "Location")
                    this.$store.state.contact_data.location = element.value
                if (element.name == "Location Link")
                    this.$store.state.contact_data.location_link = element.value
                if (element.name == 'Linkedin')
                    this.$store.state.contact_data.linkedin = element.value
            });
        }

    },
    mounted() {
        this.lang = localStorage.getItem("lang");
        this.getService()
        this.getPartner()
        this.getAbout()
        this.getClient()
        this.getProductType()
        this.getProduct()
        this.getContact()
        this.scroll = localStorage.getItem("scroll")
        this.$scrollTo("#" + this.scroll)
    },
};
</script>

<style lang="scss">
.landing {
    height: 1000px;
}

@keyframes up-and-down {
    from {
        // opacity: 0;
        // transform: scale(70%);
        transform: translateY(50px);
    }

    to {
        // opacity: 1;
        // transform: scale(80%);
        transform: translateX(0px);
    }
}

.animation {
    animation-name: up-and-down;
    animation-duration: 0.7s;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    position: absolute;
    top: 50%;
}
</style>
